import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subject, forkJoin, takeUntil } from 'rxjs';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent implements OnInit, OnDestroy
{
  selectedItem: string = '';
  items = [
    { "Name": 'Governing Body', "Url": 'governing-body', },
    { "Name": 'Commander Message', "Url": 'commander-message'},
    { "Name": 'Chairman Message', "Url": 'chairman-message'},
    // { "Name": 'Education Assistant,', "Url": 'education Assistant'},
    // { "Name": 'Administrative Staff', "Url": 'administrative-staff'},
    { "Name": 'Principal Message', "Url": 'principal-messege', },
    // { "Name": 'Volunteer', "Url": 'volunteer', },
  ];
  imageLoaded = false;
  fetchinData = true;
  ImageAlbums: any;
  GBs: any;
  GBs1: any;
  GBs2: any;
  GBs3: any;
  GBs4: any;
  TeacherInfo: any;
  GBms: any;
  GBms1: any;
  selectedItemName = '';
  private ngUnsubscribe = new Subject();

  constructor(private route: ActivatedRoute, private location: Location, private appService: AppService, private router: Router, private _changeDetectorRef: ChangeDetectorRef,) { }

  ngOnInit()
  {
    this.route.paramMap.subscribe((params: ParamMap) =>
    {
      const item = params.get("item");
      const matchedItem = this.items.find(i => i.Url === item);
      if (item && matchedItem && item == matchedItem.Url)
      {
        this.selectedItem = item;
        this.selectedItemName = matchedItem.Name

      } else
      {
        this.selectedItem = this.items[0].Url;
        this.selectedItemName = this.items[0].Name
        this.location.replaceState(`/${this.selectedItem}`);
      }
      this.FetchData();
    });

  }

  ngOnDestroy()
  {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  FetchData()
  {
    this._changeDetectorRef.markForCheck();
    this.fetchinData = true;
    if (this.selectedItem === 'governing-body')
    {
      this.FetchGbs();
    } else if (this.selectedItem === 'volunteer')
    {
      this.FetchTeacherInfo();
    } else
    {
      this.FetchGbms();
    }
  }

  selectItem(item: string)
  {
    this.selectedItem = item;
    if (this.selectedItem === 'governing-body')
    {
      this.router.navigate([`/administration/${item}`]);
    } else if (this.selectedItem === 'volunteer')
    {
      this.router.navigate([`/administration/${item}`]);
    } else
    {
      this.location.go(`/administration/${item}`);
      if (this.GBms != null)
      {

        const matchedItem = this.items.find(i => i.Url === item);
        this.selectedItemName = matchedItem.Name;

        let gm = null;

        if (this.selectedItem === 'message-of-head-master')
        {
          gm = this.GBms.filter(item => item.GBDesignationId == 41);
        }
        else if (this.selectedItem === 'chairman-message')
          {
            gm = this.GBms.filter(item => item.GBDesignationId == 4);
          }
          else if (this.selectedItem === 'principal-messege')
            {
              gm = this.GBms.filter(item => item.GBDesignationId == 6);
            }
        this.GBms1 = gm[0];
      }
      else
      {
        this._changeDetectorRef.markForCheck();
        this.fetchinData = true;
        this.FetchGbms();
      }

    }
  }

  onImageLoad()
  {
    this.imageLoaded = true;
  }

  FetchGbs() {
    forkJoin([
        this.appService.getGBs(),
    ]).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((response: any) => {
        this.GBs = response[0].data;

        if (this.GBs) {
            // Reset data to avoid duplication
            this.GBs1 = null;
            this.GBs2 = [];
            this.GBs3 = [];
            this.GBs4 = [];

            // First item for the first row
            this.GBs1 = this.GBs.slice(0, 1)[0];

            // Three items for the second row
            this.GBs2 = this.GBs.slice(1, 4);

            // Three items for the third row
            this.GBs3 = this.GBs.slice(4, 7);

            // Remaining items for the fourth row
            this.GBs4 = this.GBs.slice(7);
        }

        this.fetchinData = false;
    });
}


  FetchTeacherInfo()
  {
    forkJoin([
      this.appService.getTeaherStaff(),
    ]).subscribe((response: any) =>
    {
      console.log(response, 'response Albums');

      this.TeacherInfo = response[0].data;
      this.fetchinData = false;
    });
  }

  FetchGbms()
  {
    forkJoin([
      this.appService.getGBMessages(),
    ]).subscribe((response: any) =>
    {
      console.log(response, 'response Albums');

      this.GBms = response[0].data;

      if (this.GBms)
      {

        let gm = null;

        if (this.selectedItem === 'message-of-head-master')
        {
          gm = this.GBms.filter(item => item.GBDesignationId == 41);
        } 
        else if (this.selectedItem === 'commander-message')
          {
            gm = this.GBms.filter(item => item.GBDesignationId == 2);
          }
          else if (this.selectedItem === 'chairman-message')
            {
              gm = this.GBms.filter(item => item.GBDesignationId == 4);
            }
            else if (this.selectedItem === 'principal-messege')
              {
                gm = this.GBms.filter(item => item.GBDesignationId == 6);
              }

       
        this.GBms1 = gm[0];
      }

      this.fetchinData = false;
    });
  }

  TransformUrl(value)
  {
    if (value.includes('https://'))
    {
      return value;
    }
    else
    {
      return `https://${value}`
    }
  }
}
